meedy.factory('meedy.termMockService', ['$q', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function($q, baseService, objectHelper, config) {

        function TermMockService() {

            this.getUpcomingTermsWithSkip = function(skipCount) {
                return baseService.get('./meedy/resource/mock/upcomingTerms.json').then(
                //return baseService.get(config.API_URL + '/upcoming/' + skipCount).then(
                    function(successResponse) {

                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getUpcomingTerms = function() {
                return baseService.get('./meedy/resource/mock/upcomingTerms.json').then(
                //return baseService.get(config.API_URL + '/upcoming').then(
                    function(successResponse) {

                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getTermDetails = function(idTerm) {
                return baseService.get(config.API_URL + '/details/' + idTerm).then(
                    function(successResponse) {

                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getMonthlyCalendarData = function(startDate) {
                return baseService.get(config.API_URL + '/monthlyData?startDate=' + startDate).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createNewInternalAppointment = function(term) {
                return baseService.post(config.API_URL + '/newInternalTerm', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createNewPrivateTerm = function(term) {
                return baseService.post(config.API_URL + '/newPrivateTerm', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermWrapperMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getCalendarData = function(startDate, calendarType, idResource) {
                return baseService.get(config.API_URL + '/getCalendarData?startDate=' + startDate + '&calendarType=' + calendarType + '&resourceId=' + idResource).then(
                    function(successResponse) {
                        //var data = objectHelper.translateArray(successResponse, TermWrapperMeedyVO);
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateInternalTermData = function(term) {
                return baseService.post(config.API_URL + '/updateInternalTerm', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updatePrivateTermData = function(term) {
                return baseService.post(config.API_URL + '/updatePrivateTermData', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.cancelAppointment = function(idTerm, cancelAppointmentWrapper) {
                return baseService.post(config.API_URL + '/cancelAppointment/' + idTerm, cancelAppointmentWrapper).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteTerm = function(idTerm) {
                return baseService.delete(config.API_URL + '/delete/' + idTerm).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getStatusReasons = function() {
                return baseService.post(config.API_URL + '/getStatusReasons').then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AppointmentStatusReasonMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.verifyAppointment = function(termVerificationWrapper) {
                return baseService.post(config.API_URL + '/verifyAppointment', termVerificationWrapper).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAppointmentBillings = function(idTerm) {
                return baseService.post(config.API_URL + '/getAppointmentBillings/' + idTerm).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AppointmentBillingOfferWrapperMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.executeAppointmentBillings = function(idTerm, dataWrapper) {
                return baseService.post(config.API_URL + '/executeAppointmentBillings/' + idTerm, dataWrapper).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.executeAppointment = function(idTerm, dataWrapper) {
                return baseService.post(config.API_URL + '/executeAppointment/' + idTerm, dataWrapper).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.checkConflicts = function(term) {
                return baseService.post(config.API_URL + '/checkConflicts', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.checkConflicts = function(term) {
                return baseService.post(config.API_URL + '/checkConflicts', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateCyclicTerm = function(mode, term) {
                return baseService.put(config.API_URL + '/updateCyclicTerm/' + mode, term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteCyclicTerm = function(mode, idTerm) {
                return baseService.delete(config.API_URL + '/updateCyclicTerm/' + mode + '/' + idTerm).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new TermMockService();
    }
]);
